import React, { Component } from 'react';

class Banner extends Component {
  constructor(props){
    super(props);
    this.state = {
      listItem: [
        { id: 1, icon: 'fa fa-check', title: 'Basado en Python' },
        { id: 2, icon: 'fa fa-check', title: 'Fundamentos de control lineal y no lineal' },
        { id: 3, icon: 'fa fa-check', title: 'Aplicaciones de Machine Learning al control automático' },
        { id: 4, icon: 'fa fa-check', title: 'Certificado de finalización incluido' },
      ]
    }
  }

  scrollToContact = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

  render() {
    return (
      <section className="banner pb-80 dark-bg">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-12 col-lg-6">
              <div className="banner-content">
                <span className="subheading">¡Inscripciones abiertas!</span>
                <h1>CURSO DE CONTROL</h1>
                <p>
                  Diseñado para estudiantes y profesionales que quieran dominar las técnicas de control de sistemas lineales y no lineales a partir de datos experimentales utilizando Python, MATLAB o C++.
                </p>
                <ul>
                  {this.state.listItem.map(data => (
                    <li key={data.id}>
                      <i className={data.icon}></i> {data.title}
                    </li>
                  ))}
                </ul>

                {/* Botón que hace scroll hasta Contact */}
                <a
                  href="#contact"
                  className="btn btn-main"
                  onClick={async (e) => {
                    e.preventDefault(); // Evita el comportamiento inmediato del enlace
                
                    // 1️⃣ Llamada al microservicio backend
                    try {
                      const backendUrl =
                        window.location.hostname === "neuralnetadaptivecontrol.com"
                          ? "https://controlbook.onrender.com"
                          : "http://localhost:3000";
                
                      await fetch(`${backendUrl}/clicks`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                          sessionId: "session-" + Math.random().toString(36).substr(2, 9),
                          elementId: "curso-control",
                          pageUrl: window.location.href,
                          elementType: "button",
                          userId: "user-react",
                          coordinates: { x: e.clientX, y: e.clientY },
                          metadata: {
                            product: "curso-neural-networks",
                            price: 299.99,
                            action: "signup-click",
                          },
                        }),
                      });
                    } catch (err) {
                      console.error("Error recording click:", err);
                    }

                    // 2️⃣ Scroll a la sección contact
                    const contactSection = document.getElementById("contact");
                    if (contactSection) {
                      contactSection.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                >
                  Inscribirme ahora 299.99 €
                </a>

                <p>
                  ¿Quieres más información?{" "}
                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={async (e) => {
                      e.preventDefault(); // Evita la navegación
                
                      // Registrar click en backend
                      try {
                        const backendUrl =
                          window.location.hostname === "neuralnetadaptivecontrol.com"
                            ? "https://controlbook.onrender.com"
                            : "http://localhost:3000";
                
                        await fetch(`${backendUrl}/clicks`, {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({
                            sessionId: "session-" + Math.random().toString(36).substr(2, 9),
                            elementId: "download-programa-is",
                            pageUrl: window.location.href,
                            elementType: "link",
                            userId: "user-react",
                            coordinates: { x: e.clientX, y: e.clientY },
                            metadata: {
                              action: "download",
                              file: "programa.pdf",
                            },
                          }),
                        });
                      } catch (err) {
                        console.error("Error recording click:", err);
                      }
                
                      // Por ahora no abrir nada
                    }}
                  >
                    Descarga el programa
                  </a>
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="banner-img">
                <img
                  src="assets/images/banner/CL_course.png"
                  alt="Curso de Control con ML"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Banner;
